// src/run-stream.ts
var e = class {
	constructor(e) {
		this.knownGroups = e, this.groups = /* @__PURE__ */ new Map();
	}
	get progress() {
		let e = 0, t = 0;
		for (let n of this.groups.values()) {
			e += n.v;
			for (let e of n.live.values()) t += e.items.length;
		}
		return [e, t];
	}
	get hasCommits() {
		return [...this.groups.values()].some((e) => e.msgs.length > 0);
	}
	apply(e) {
		switch (e.t) {
			case "saved": {
				let t = this.group(e.group);
				if (t == null || e.v <= t.v) return;
				t.v = e.v, t.msgs = e.msgs;
				for (let [n, r] of t.live) r.epoch < e.v && t.live.delete(n);
				return;
			}
			case "live": {
				let t = this.group(e.group);
				if (t == null || e.epoch < t.v || e.data.type === "keepalive") return;
				this.applyLive(t, e.key, e.epoch, e.attempt, e.data);
				return;
			}
			case "end":
				this.ended = e.status;
				return;
		}
	}
	messages() {
		return [...this.groups.values()].flatMap((e) => [...e.msgs, ...this.liveMessages(e).flatMap((e) => e.type === "tool_call_delta" ? [] : [e])]);
	}
	toolCallsInProgress() {
		let e = /* @__PURE__ */ new Map();
		for (let t of this.groups.values()) for (let n of this.liveMessages(t)) {
			if (n.type !== "tool_call_delta") continue;
			let { id: t, name: r, args: i } = n.tool_call_delta, a = e.get(t) ?? {
				id: t,
				name: r,
				args: ""
			};
			a.args += i, e.set(t, a);
		}
		return [...e.values()];
	}
	liveMessages(e) {
		return [...e.live.values()].flatMap((e) => e.items);
	}
	group(e) {
		if (this.knownGroups.has(e)) return;
		let t = this.groups.get(e) ?? {
			v: 0,
			msgs: [],
			live: /* @__PURE__ */ new Map()
		};
		return this.groups.set(e, t), t;
	}
	applyLive(e, t, n, r, i) {
		let a = e.live.get(t);
		if (a != null && (n < a.epoch || n === a.epoch && r < a.attempt)) return;
		let o = a == null || n > a.epoch || r > a.attempt ? {
			epoch: n,
			attempt: r,
			items: []
		} : a;
		o.items.push(i), e.live.set(t, o);
	}
};
export { e as CopilotRunState };
